'use strict';

/**
* Overriding from base SFRA to fix nested collapsibles
*/

module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
        $('body').on('click', selector, function (e) {
            e.preventDefault();

            if (window.isMobile() && $(this).closest('.collapsible-' + size).data('expand-mobile') == 'not-collapsible') {
                return;
            }

            $(this).closest('.collapsible-' + size).toggleClass('active');

            if ($(this).closest('.collapsible-' + size).hasClass('active')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
        });
    });
};
